module.exports = __webpack_public_path__ + "static/media/stacker-logo-white.ca1fd549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stacker-logo-white.png
// module id = 202
// module chunks = 3